/**
 * Printer Configuration
 * List of printers available for PRINT-MACH operation
 */

export const PRINTERS = [
  // S80600 Roll-fed Printers (named after musicians)
  { id: 'cash', name: 'CASH', model: 'S80600', icon: 'cash' },
  { id: 'willie', name: 'WILLIE', model: 'S80600', icon: 'willie' },
  { id: 'jt', name: 'JT', model: 'S80600', icon: 'jt' },
  { id: 'elvis', name: 'ELVIS', model: 'S80600', icon: 'elvis' },
  { id: 'eminem', name: 'EMINEM', model: 'S80600', icon: 'eminem' },
  { id: 'prince', name: 'PRINCE', model: 'S80600', icon: 'prince' },
  { id: 'chester', name: 'CHESTER', model: 'S80600', icon: 'chester' },
  // LEF Flatbed UV Printers
  { id: 'eddie', name: 'EDDIE', model: 'LEF', icon: 'eddie' },
  { id: 'lef-prince', name: 'LEF-PRINCE', model: 'LEF', icon: 'lef-prince' },
  // Roland VersaObject
  { id: 'ozzie', name: 'OZZIE', model: 'VO', icon: 'ozzie' },
  // UV Roll-fed
  { id: 'postmalone', name: 'POST MALONE', model: 'UV Rollfed', icon: 'postmalone' },
];

// Operation code that requires printer selection
export const PRINT_MACH_OPERATION = 'PRINT-MACH';

// Operation code for Color Dev (also requires printer selection)
export const COLOR_DEV_OPERATION = 'COLOR DEV';

// Operation code for rework (PA users get prompted for printing vs other)
export const REWORK_OPERATION = 'REWORK';
